import React, { useState, useEffect, useRef, useContext } from "react";
import { Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function BrandLogo(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    props.setBase64Img(base64Img);
  }, [base64Img]);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (props.logo || base64Img) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  let defaultLogo = require("images/icons/company-logo.png");
  const inputRef = useRef();
  const [imageURL, setImageURL] = useState(props.logo ? props.logo : `/datapulse${defaultLogo}`);
  const [fileName, setFileName] = useState("No File Chosen");
  const [base64Img, setBase64Img] = useState(props.base64Img);
  let companyLogo = <img style={{ maxWidth: "101px", maxHeight: "101px", width: "auto", height: "auto" }} src={imageURL} />;

  const encodeImageFileAsURL = (element) => {
    let file = element.files[0];
    let reader = new FileReader();
    if (file.size > 10000000) {
      alert("Image must be less than 10MB. Consider use another image or compress this one.");
    }
    reader.onloadend = () => {
      setBase64Img(reader.result);
      props.setBase64Img(reader.result);
    };
    reader.readAsDataURL(file);
  };
  return (
    <>
      <Row className=" pb-3 justify-content-center">
        <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
        <Col style={{ backgroundColor: "#EEEEEE" }} className=" d-flex flex-column align-items-center mb-2 pb-2 ">
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Company Logo</p>
          </div>
          <div>
            <p className=" f16 nunito-regular primary text-center">Upload the brand logo here.</p>
          </div>
          <div className="pb-3">{companyLogo}</div>
          <div className="pb-3">
            <input
              style={{ backgroundColor: "#3291C1", display: "none" }}
              name="logo"
              className="py-1 m-2"
              type="file"
              ref={inputRef}
              onChange={(e) => {
                setImageURL(URL.createObjectURL(e.target.files[0]));
                setFileName(e.target.files[0].name);
                encodeImageFileAsURL(e.target);
              }}
            />

            <Button style={{ backgroundColor: "#3291C1" }} className="px-3 btn-sm m-2" onClick={() => inputRef.current.click()}>
              Choose File
            </Button>
          </div>
          <div className="pb-3">
            <p className="f16 nunito-regular primary">{fileName}</p>
          </div>
          <div>
            <p className="f10 primary nunito-regular text-center">
              Square image no less than 300x300 is ideal. Maximum <br></br> file size is 2MB. Supported files: JPG, PNG
            </p>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton validated={validated} btnText={`Next`} nextPage={nextPage.url} invalidText={`Logo must be uploaded`} submitForm={props.submitForm} />
          </div>
        </Col>
      </Row>
    </>
  );
}
